import React from "react";
import {useTranslation} from "react-i18next";

const BookingLoginZuumeHeader = (props: {title: string}) => {
    const {t} = useTranslation();
    return <h1 className={"text-gray-900 text-4xl md:text-[64px] md:leading-none font-zuume font-bold"}>{props.title}</h1>;
};

export default BookingLoginZuumeHeader;
